import React from "react";
import { ReviewDecisionComponent } from "../reviewDecisionComponent";
import { CommentComponent } from "../commentComponent";
import { isNullOrEmptyString, isNullOrUndefined } from "../../common/utils";
import "./index.scss";
import AuthZButton from "../AuthzButton";

export const BatchEditComponent = ({
                                     id,
                                     selectedCount,
                                     onCancel,
                                     defaultAction,
                                     defaultComment,
                                     defaultDecisionReason,
                                     isCommentRequired,
                                     handleActionChange,
                                     isActionRequired,
                                     handleCommentChange,
                                     onSubmit,
                                     getPopupContainer,
                                   }) => {
  const disableSubmit = isCommentRequired || isNullOrEmptyString(defaultAction);
  return (
    <div id={id} className={"batchEdit"}>
      <div className={"batchEdit-selected-count"}>
        <b>{selectedCount} Selected</b>
      </div>
      <div>
        <div className="batctEditActions">
          <ReviewDecisionComponent
            placeHolder={"Select decision"}
            selected={defaultAction}
            handleChange={handleActionChange}
            mandatory={isActionRequired || isNullOrUndefined(defaultAction)}
            getPopupContainer={getPopupContainer}
          />
          <div style={{ paddingLeft: "8px" }}>
            <CommentComponent
              selectedReason={defaultDecisionReason}
              disabled={isNullOrUndefined(defaultAction)}
              placeHolder={"Add comment"}
              comment={defaultComment}
              onChange={handleCommentChange}
              onlyComment={defaultAction === "No change needed" || isNullOrUndefined(defaultAction)}
              getPopupContainer={getPopupContainer}
            />
          </div>
          <div style={{ paddingLeft: "20px" }}>
            <AuthZButton authZButtonType="secondary" onClick={onCancel}>
              Cancel
            </AuthZButton>
          </div>
          <div style={{ paddingLeft: "8px" }}>
            <AuthZButton
              authZButtonType="secondary"
              onClick={onSubmit}
              buttonDisabled={disableSubmit}
            >
              Apply
            </AuthZButton>
          </div>
        </div>
      </div>
    </div>
  );
};
